(function($) {

  function updateProductPrice() {
    // Update price according to variable price
    if ($('form.variations_form').length !== 0) {
      var existCondition = setInterval(function() {
        if ($('.woocommerce-variation-price').length) {
          console.log("Exists!");
          clearInterval(existCondition);
          $('.summary .product-custom-price').html($('.woocommerce-variation-price').html());
        }
      }, 100); // check every 100ms

      $('.variations_form').on('woocommerce_variation_has_changed', function () {
        $('.summary .product-custom-price').html($('.woocommerce-variation-price').html());
      });
    }
  }

  function toggleNavigation() {
    var $siteNavigationWrapper = $('#site-navigation');
    var $closeMenuTrigger = $('.close-menu-trigger');
    console.log($siteNavigationWrapper);
    var $navToggleButton = $('button#menu-toggle');
    $navToggleButton.click(function () {
      if ($siteNavigationWrapper.hasClass('nav-open')) {
        $siteNavigationWrapper.removeClass('nav-open');
      } else {
        $siteNavigationWrapper.addClass('nav-open');
      }
    });

    $closeMenuTrigger.click(function () {
      if ($siteNavigationWrapper.hasClass('nav-open')) {
        $siteNavigationWrapper.removeClass('nav-open');
      } else {
        $siteNavigationWrapper.addClass('nav-open');
      }
    });
  }

  function toggleSearchBar() {
    var $siteSearch = $('.site-search');
    var $searchToggleButton = $('.header__main__top').find('.site-search--trigger');
    $searchToggleButton.click(function () {
      if ($siteSearch.is(':hidden')) {
        $siteSearch.show();
      } else {
        $siteSearch.hide();
      }
    })
  }

  $(document).ready(function() {
    updateProductPrice();
    toggleSearchBar();
    toggleNavigation();
    $(window).resize(function() {

    });
  });

})(jQuery);
